//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable no-lonely-if */
import { ref, watch, onMounted } from '@vue/composition-api'
import {
  mdiVideoOutline,
  mdiVideoOffOutline,
  mdiCrownOutline,
} from '@mdi/js'
import 'video.js/dist/video-js.css'
import { useUtils } from '@core/libs/i18n'
import { useRouter, formatCurrency } from '@core/utils'
import themeConfig from '@themeConfig'
import useVideoData from '@core/utils/useVideoData'

export default {
  setup() {
    const { t } = useUtils()
    const { router } = useRouter()
    const { videoData, currentVideoData, updateVideoData } = useVideoData()

    const loginForm = ref(null)
    const itemSelected = ref(0)

    const premiumVideo = ref('https://fanaty-production-ohio.s3.amazonaws.com/highlights/685e0c38/highlight_with_outro.mp4')
    const basicVideo = ref('https://fanaty-production-ohio.s3.amazonaws.com/highlights/0da96093/highlight_with_outro.mp4')
    const playerOptions = ref({
      controls: false,
      responsive: true,
      breakpoints: true,
      fill: true,
      autoplay: true,
      muted: true,
      loop: true,
      language: 'en',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [],
      notSupportedMessage: 'Este video no está disponible temporalmente, intente nuevamente más tarde.',
      usingPlugin: true,
      fluid: true,
      aspectRatio: '16:9',
    })
    const videoLoaded = ref(false)

    const onContinue = async () => {
      if (itemSelected.value === 0) router.push({ name: 'views-pay-video' })
      else {
        if (videoData.value.match) router.push({ path: `/game/${videoData.value.match}` })
        else {
          videoData.value.video.check_redirect = true
          await updateVideoData(videoData.value)

          const hash = videoData.value.video.video_share_url.split('/r/')[1]
          router.push({ name: 'recording', params: { hash } })
        }
      }
    }

    const playerReadied = () => {
      videoLoaded.value = true
      const videoHTML = document.getElementsByTagName('video')
      if (videoHTML.length) {
        videoHTML[0].style.backgroundColor = '#333333'
        videoHTML[0].classList.add('bg-grey')
      }
    }

    watch([itemSelected], () => {
      videoLoaded.value = false
      if (itemSelected.value === 0) {
        playerOptions.value.sources = [{
          type: 'video/mp4',
          src: premiumVideo.value,
        }]
      } else {
        playerOptions.value.sources = [{
          type: 'video/mp4',
          src: basicVideo.value,
        }]
      }
    })

    onMounted(() => {
      Object.assign(videoData.value, currentVideoData.value)

      playerOptions.value.sources.push({
        type: 'video/mp4',
        src: premiumVideo.value,
      })
    })

    return {
      // data
      loginForm,
      itemSelected,
      videoData,

      premiumVideo,
      basicVideo,
      playerOptions,
      videoLoaded,

      // methods
      formatCurrency,
      onContinue,
      playerReadied,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,

      t,

      icons: {
        mdiVideoOutline,
        mdiVideoOffOutline,
        mdiCrownOutline,
      },
    }
  },
}
